var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_687_376",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.309326,
    y: 0.00827026,
    width: 16,
    height: 16,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_687_376)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3093 8.00827C16.3093 8.00827 13.3093 2.50827 8.30933 2.50827C3.30933 2.50827 0.309326 8.00827 0.309326 8.00827C0.309326 8.00827 3.30933 13.5083 8.30933 13.5083C13.3093 13.5083 16.3093 8.00827 16.3093 8.00827ZM1.48233 8.00827C1.96585 8.74315 2.52198 9.42758 3.14233 10.0513C4.42933 11.3403 6.18933 12.5083 8.30933 12.5083C10.4293 12.5083 12.1883 11.3403 13.4773 10.0513C14.0977 9.42758 14.6538 8.74314 15.1373 8.00827C14.6538 7.27339 14.0977 6.58895 13.4773 5.96527C12.1883 4.67627 10.4283 3.50827 8.30933 3.50827C6.18933 3.50827 4.43033 4.67627 3.14133 5.96527C2.52097 6.58896 1.96484 7.2734 1.48132 8.00828L1.48233 8.00827Z",
    fill: "#E4002B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30933 5.50827C6.92862 5.50827 5.80933 6.62755 5.80933 8.00826C5.80932 9.38897 6.9286 10.5083 8.30931 10.5083C9.69002 10.5083 10.8093 9.38899 10.8093 8.00828C10.8093 6.62757 9.69005 5.50828 8.30934 5.50827H8.30933ZM4.80933 8.00827C4.80933 6.75784 5.47642 5.6024 6.55933 4.97718C7.64223 4.35197 8.97642 4.35197 10.0593 4.97718C11.1422 5.60239 11.8093 6.75784 11.8093 8.00827C11.8093 9.2587 11.1422 10.4141 10.0593 11.0394C8.97642 11.6646 7.64223 11.6646 6.55933 11.0394C5.47642 10.4141 4.80933 9.2587 4.80933 8.00827V8.00827Z",
    fill: "#E4002B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.5c610a1f28355a275e2bb3d961fccf80.svg";
export { ForwardRef as ReactComponent };